<template>
  <div @click="show=false">
    <el-row class="panel">
      <el-col :span="24" class="panel-top">
        <el-col :span="14" style="font-size:26px;">
          <img src="../assets/img/aicon02.png" class="logo" @click="handleHyy" style="cursor: pointer;"/>
        </el-col>
        <el-col :span="10" class="right_action">
          <div style="position: relative;" class="rightbar">
            <span class="el-dropdown-link" style="cursor: pointer;">
              <strong class="imgUrlstrong">{{imgUrl}}</strong>
              <!-- <img :src="src" class="head" /> -->
              <span @click.stop="show=!show" class="name">
                <!-- <i style="color:#888;">hello</i> -->
                <span class="strongName">{{username}}</span>
              </span>
              <img class="usermessage" @click.stop="show=!show" src="../assets/img/aicon42.png" alt style="padding-left:10px;"/>
              <div v-show="show" class="xiugai">
                <span class="mimaxiugai xgmmClass" @click="handleModify(1)">修改密码</span>
                <span class="mimaxiugai gzgzhClass" @click="handleModify(2)" >修改手机</span>
              </div>
            </span>
          </div>
          <div class="closeImg">
            <img src="../assets/img/aicon12_03.png" class="login_out" @click="logout()" />
          </div>
        </el-col>
      </el-col>
      <el-col :span="24" class="panel-center">
        <!-- 左侧菜单栏 -->
        <aside id="leftMenu">
          <el-menu :default-active="$route.path" theme="dark" unique-opened router class="el-menu-vertical-demo">
            <template v-for="(item,index) in menu">
              <el-submenu :index="index+''" :key="index+''" v-if="item.childs.length>0" :default-active="item.menuurl">
                <template slot="title">
                  <img :src="item.icon" style="width: 18px;"/>
                  <i class="have first_title">{{item.menuname}}</i>
                </template>

                <template v-for="item in item.childs">
                  <!-- <el-submenu :index="index+''" :key="index+''" :default-active="item.menuurl"> -->
                    <!-- <template slot="title">
                      <img :src="item.icon" style="width: 18px;"/>
                      <i class="have first_title">{{item.menuname}}</i>
                    </template> -->
                    <el-menu-item v-for="child in item.childs" @click="menuTab" :key="child.menuid" :index="child.menuurl"
                      :default-active="item.menuurl" :data-parentId="item.menuid" :data-id="child.menuid">{{child.menuname}}</el-menu-item>
                  <!-- </el-submenu> -->

                  <el-menu-item @click="menuTab" :index="item.menuurl" :key="item.menuurl"
                  :default-active="item.menuurl" :data-id="item.menuid" :data-parentId="item.menuid">
                    <!-- <i :class="item.iconCls"></i> -->
                    <!-- <img :src="item.icon" style="width: 18px;"/> -->
                    <i class="first_title">{{item.menuname}}</i>
                  </el-menu-item>
                </template>
                <!-- <el-menu-item v-for="child in item.childs" @click="menuTab" :data-parentId='item.menuid' :data-id="child.menuid" :index="child.menuurl" :key="child.index">{{child.menuname}}</el-menu-item> -->
              </el-submenu>

              <el-menu-item @click="menuTab" :data-id="item.menuid" :index="item.menuurl" :key="item.menuurl"
               :data-parentId="item.menuid" v-else class="yijimenu">
                <!-- <i :class="item.iconCls"></i> -->
                <img :src="item.icon" style="width: 18px;"/>
                <i class="first_title">{{item.menuname}}</i>
              </el-menu-item>
            </template>
          </el-menu>
        </aside>
        <section class="panel-c-c" ref="main_container">
          <div class="panel_nav">
            <el-col :span="24" class="nav">
              <!-- <strong style="width:200px;float:left;color: #475669;">{{currentPathName}}</strong> -->
              <el-breadcrumb separator="/">
                <!-- <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item> -->
                <el-breadcrumb-item v-for="(item,index) in this.$route.meta" :key="index" :to="item.url">
                  <router-link v-if="item.url" :to="item.url">{{item.name}}</router-link>
                  <a v-else>{{item.name}}</a>
                </el-breadcrumb-item>
              </el-breadcrumb>
              <!-- <el-breadcrumb separator=">">
                <el-breadcrumb-item v-if="currentPathNameParent!=''">{{currentPathNameParent}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="currentPathName!=''">{{currentPathName}}</el-breadcrumb-item>
              </el-breadcrumb> -->
            </el-col>
            <div style="margin-right:0px" class="view_container clearfix">
              <el-col :span="24" class="clearfix" style="background-color:#fff;box-sizing: border-box;">
              <keep-alive include="answer,refund,brand">
                <router-view :menuAction="menuAction"></router-view>
              </keep-alive>
              </el-col>
            </div>
          </div>
        </section>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { asideMenu, loginout } from "../api/newOss";
export default {
  data() {
    return {
      routerList: [
        [
          {
            path: "/Activitycolumn",
            childerPath: [
              { path: "/Newproducts" }
            ]
          },{
            path:"/brand",
            childerPath:[
            {
              path:"/examine"
            },{
              path:"/findshop" 
            }]
          },{
            path:"/refund",
            childerPath:[
              {
                path:"/serviceRefund"
              },{
                path:"/serviceExchange" 
              },{
                path:"/serviceRepair" 
              }
            ]
          },{
            path:"/listdes",
            childerPath:[{
              path:"/designerList"
            }]
          },{
              path:"/companyList",
              childerPath:[{
                  path:"/company"
              }]
          },{
              path:"/answer",
              childerPath:[{
                  path:"/add"
              }]
          },{
            path:"/coupon",
            childerPath:[{
                path:"/couponadd"
            }]
          },{
            path:"/MemberList",
            childerPath:[{
                path:"/MemberDetails"
            }]
          },{
            path:"/ActivityManagement",
            childerPath:[{
                path:"/ActivityDetails"
            }]
          }
        ]
        
      ],
      imgUrl: "",
      show: false,
      currentPath: "",
      currentPathName: "广告管理",
      currentPathNameParent: "",
      menuAction: [],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      menu: [],
      username: "",
      // username: this.$cookie.get("Name")
      userId: this.$cookie.get("OperatorId"),
    };
  },
  watch: {
    $route(to, from) {
      localStorage.setItem("name", to.name);
      localStorage.setItem("parentName", to.matched[0].name);
      localStorage.setItem("currentPath", to.path);
      //监听路由改变
      this.routerList.filter((item,index) => {
       item.filter((itemsss,indexsss) => {
          itemsss.childerPath.filter((itemChilder,indexChilder) => {
           if(this.$route.path==itemChilder.path){
             this.$nextTick(()=> {
             this.currentPath=itemsss.path
             })
           }else{
              this.currentPath=to.path;
           }
        })
       })
      })
      // this.currentPath = to.path;
      this.currentPathName = to.name;
      this.currentPathNameParent = to.matched[0].name;
      this.$refs.main_container.scrollTop = 0;
      this.getId();
    }
  },
  methods: {
    handleHyy() {
      this.$router.push('/welcome'); // 欢迎首页
    },
    //修改密码 & 修改手机
    handleModify(type) {
      this.$router.push({
        path: "/modify",
        query: { type: type, },
      });
      this.show = false;
    },
    getId() {
      let that = this;
      for (let obj of this.menu) {
        let firstId = obj.menuid;
        if (obj.menuurl == this.currentPath) {
          that.$cookie.set("menuId", firstId);
          that.$cookie.set("parentId", firstId);
          // that.getFuncNode();
        } else {
          for (let sec of obj.childs) {
            if (sec.menuurl == this.currentPath) {
              that.$cookie.set("menuId", sec.menuid);
              that.$cookie.set("parentId", firstId);

              // that.getFuncNode();
            }
          }
        }
      }

      // this.getFuncNode();
    },
    menuTab(e) {
      // e.$el.classList.add("is-activeel")
      let data = e.$el.dataset;
      this.$cookie.set("menuId", data.id);
      this.$cookie.set("parentId", data.parentid);
      // this.getFuncNode();
    },

    // 获取员工的信息
    getstraffinfo() {
      let userId = this.$cookie.get("OperatorId");
      var loginParams = {
        userId: userId
      };
      if (userId) {
        chayuangong(loginParams).then(data => {
          this.username = data.ResultObj.Name;
          this.imgUrl = this.username.slice(0, 1);
          if (data.ResultObj.FaceUrl != null) {
            this.src = data.ResultObj.FaceUrl;
          }
        });
      }
    },
    getFuncNode() {
      asideMenu({},this.userId).then(r => {
        let actionId = [],
        obj = r.resultObj;
        obj.forEach(element => {
          actionId.push(element.menuid);
          element.icon = element.icon.replace("assets", "static");
        });
        this.$cookie.set("actionId", actionId);
        this.menuAction = actionId;
        this.menu = obj;
      });
    },
    // 退出登录
    logout() {
      var _this = this;
      this.$swal({
        type: "warning",
        text: "确认退出吗?",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(val => {
        if (val.value) {
          loginout('').then(data=>{
            if(data.resultCode == 1){
              localStorage.setItem("currentPath", "/banner");
              _this.$router.replace("/login");
              _this.$cookie.remove("menuId");
              _this.$cookie.remove("parentId");
              _this.$cookie.remove("BrandId");
              _this.$cookie.remove("OpenId");
              _this.$cookie.remove("OperatorId");
              _this.$cookie.remove("Phone");
            }
          })
        }
      }).catch(() => {});
    },
    loadScriptsAndStyles() {
      // 动态插入样式表
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.bootcss.com/sweetalert/1.1.3/sweetalert.min.css';
      document.head.appendChild(link);

      // 动态插入脚本
      const script1 = document.createElement('script');
      script1.src = 'https://webapi.amap.com/maps?v=1.4.4&key=c3235a448f86d476adb3e5d260616fd8&plugin=AMap.Autocomplete,AMap.PlaceSearch&plugin=AMap.DistrictSearch&plugin=AMap.Geocoder';
      script1.onload = () => {
        // console.log('高德地图 API 加载完成');
        window.AMap = window.AMap; // 将 AMap 挂载到全局对象上
      };
      document.body.appendChild(script1);

      const script2 = document.createElement('script');
      script2.src = 'https://cache.amap.com/lbs/static/PlaceSearchRender.js';
      script2.onload = () => {
        // console.log('高德地图 PlaceSearchRender 加载完成');
      };
      document.body.appendChild(script2);

      const script3 = document.createElement('script');
      script3.src = 'https://gosspublic.alicdn.com/aliyun-oss-sdk-4.4.4.min.js';
      script3.onload = () => {
        // console.log('阿里云 OSS SDK 加载完成');
      };
      document.body.appendChild(script3);
    }
  },
  mounted() {
    localStorage.name = this.currentPathName;
    localStorage.parentName = "";
    this.currentPathName = localStorage.getItem("name");
    this.currentPathNameParent = localStorage.getItem("parentName");
    this.currentPath = localStorage.getItem("currentPath");
    // this.getstraffinfo();
    this.username = localStorage.Name; // 用户名
    this.imgUrl = this.username.slice(0, 1); // 用户头像
    let thisuserkey = localStorage.getItem('userkey');
    if(thisuserkey){
      this.getFuncNode();
    }
  },
  created() {
    // let menuId = this.$cookie.get("menuId");
    // menuId ? (this.$cookie.set("menuId", 2), this.$cookie.set("parentId", 2)) : "";
    // this.getFuncNode();
    // var that = this;
    //     document.addEventListener('click',function(e){
    //                 if(e.target.className!='usermessage' ){
    //                 that.show = false
    //                 return false
    //                 }else if(e.target.className!='rightbar'){
    //                       that.show = false
    //                        return false
    //               }

    // })
    this.loadScriptsAndStyles();
  }
};
</script>
<style>
.el-menu {
  background-color: #303133;
}
</style>
<style scoped>
.mimaxiugai:hover {
  color: #F56C6C !important;
}
/* 修改密码 */
.xgmmClass {
  display: block;
  margin-bottom: 11px;
  margin-left: 10px;
  color: rgb(136, 136, 136);
  line-height: 0px;
  margin: 30px 10px 20px 20px;
  margin-top: 25px;
}
/* 关注公众号 */
.gzgzhClass {
  display: block;
  margin-bottom: 11px;
  margin-left: 10px;
  color: rgb(136, 136, 136);
  line-height: 10px;
  margin: 30px 10px 20px 20px;
}
.name {
  display: inline-block;
  margin-left: 12px;
}
.imgUrlstrong {
  width: 40px;
  height: 40px;
  background: #3396fb;
  border-radius: 50%;
  margin-top: 10px;
  color: #fff;
  display: inline-block;
  margin-left: 30px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  float: left;
}
.strongName{
  width:140px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  font-size:16px;
  color:#333;
}
.panel {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
#leftMenu {
  width: 210px;
  height: 100%;
  overflow-y: auto;
}

#leftMenu::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
#leftMenu::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #999;
  background: #ededed;
}
#leftMenu::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px #999;
  border-radius: 10px;
  background: #ededed;
}
.panel-top {
  height: 60px;
  line-height: 60px;
  background: #fff;
  color: #c0ccda;
}
/* 菜单栏图标 */
.el-menu-vertical-demo img {
  margin-right: 4px;
}
/* 菜单栏文字颜色 */

.el-menu-item {
  color: #555;
}
/* 二级菜单文字颜色 */
.el-submenu__title {
  color: #ccc;
}
/*无孩子的一级菜单 选中时字体颜色 */
.el-menu-item:hover {
  color: #555;
}
.el-menu-item i.first_title,
.el-submenu__title i {
  color: #ccc;
}
.el-menu-item.is-active {
  color: #555 !important;
  background: #fff;
}
.el-menu-item.is-activeel {
  color: #555 !important;
  background: #fff;
}

/* 有孩子的一级菜单 */

.el-submenu:hover {
  color: #555;
  background: #fff;
}
.el-menu-item:hover .first_title,
.el-menu-item.is-active .first_title {
  color: #555;
}

/* 菜单栏背景色 */
.el-menu {
  background: #333;
}
.el-menu-item.is-active:hover {
  background-color: #fff;
  color: #555;
}
.el-menu--dark {
  background: #333;
}
/* 二级菜单背景色 */
.el-submenu .el-menu-item {
  background: #222;
  padding-left: 75px;
}
/* 二级菜单选中时背景色 */
.el-submenu .el-menu-item:hover {
  background-color: #fff;
}
/* 顶部栏 */
/*左侧 甄惠装logo */
.panel-top .logo {
  width: 115px;
  height: 36px;
  float: left;
  margin: 13px 10px 10px 35px;
}
.right_action {
  text-align: right;
}
/* 右侧 登录人员 */
.panel-top .rightbar {
  text-align: left;
  min-width: 290px;
  /* border-left: 1px solid rgba(237, 237, 237, 1); */
  display: inline-block;
  /* float: left; */
}
.panel-top .rightbar .el-dropdown {
  /* width: 240px; */
  padding: 0 20px 0 20px;
  text-align: center;
  border-right: 1px solid rgba(237, 237, 237, 1);
}

.panel-top .rightbar .head {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px 10px 10px 30px;
  float: left;
}
/* 退出按钮 */
.closeImg {
  width: 78px;
  text-align: center;
  display: inline-block;
}
.panel-top .login_out {
  width: 26px;
  cursor: pointer;
}
.panel-center {
  background: #333;
  position: absolute;
  top: 60px;
  bottom: 0px;
  overflow: hidden;
}
/* 右侧 主体部分 */
.panel-c-c {
  background: #fff;
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  left: 210px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* 面包屑 */
.panel-c-c .panel_nav {
  height: 35px;
  background: #f2f2f2;
}

.panel-c-c .panel_nav .nav {
  height: 35px;
  margin-left: 25px;
  float: left;
}
.panel-c-c .panel_nav .el-breadcrumb {
  line-height: 35px;
  cursor: pointer;
}
.xiugai {
  position: absolute;
  z-index: 100;
  width: 95px;
  height: auto;
  border: 1px solid #eee;
  background: #fff;
  right: 98px;
  top: 59px;
  border-top: none;
  box-shadow: 0px 9px 10px 0px rgba(14, 5, 10, 0.1);
}
/* 去掉一级选中样式 */
.yijimenu{
  background-color: inherit !important;
}
.yijimenu:hover .first_title{
  color: #ccc;
}
.yijimenu.is-active .first_title {
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// Home.vue?0dcbcace